// stores/dialog.js
import { defineStore } from 'pinia'

export const useDialogStore = defineStore('dialog', {
    state: () => ({
        show: false,
        title: '',
        message: ''
    }),

    actions: {
        open(title, message) {
            this.title = title
            this.message = message
            this.show = true
        },

        close() {
            this.show = false
        }
    }
})